import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=ff1ce202&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=ts"
export * from "./CourseCard.vue?vue&type=script&lang=ts"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=ff1ce202&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ce202",
  null
  
)

export default component.exports